import { useState, useEffect } from "react";
import { fetchSuggestions } from "../services/chatbotService";

export const useSuggestions = () => {
  const [suggestions, setSuggestions] = useState([]);
  const [loadingSuggestions, setLoadingSuggestions] = useState(false);

  const fetchSuggestionsData = async () => {
    setLoadingSuggestions(true);
    try {
      const data = await fetchSuggestions();
      const mapped = data.map((item) => ({
        text: item.SubSubject,
        icon: item.Icon || "fal fa-sparkles",
        topicId: item.TopicId,
      }));
      setSuggestions(mapped);
    } catch (err) {
      console.error("Failed to fetch suggestions from API, falling back to static ones", err);
      setSuggestions([
        { text: "كان وأخواتها", icon: "fal fa-scroll" },
        { text: "الأسماء الخمسة", icon: "fal fa-list-ol" },
        { text: "حروف الجر", icon: "fal fa-link" },
        { text: "المفعول به (قواعد)", icon: "fal fa-pen-nib" },
        { text: "تحليل النص الشعري والقصصي", icon: "fal fa-feather-alt" },
        { text: "فهم المقروء واستخلاص الأفكار", icon: "fal fa-file-alt" },
        { text: "مهارات الاستماع والتحليل المسموع", icon: "fal fa-headset" }

      ]);
    } finally {
      setLoadingSuggestions(false);
    }
  };

  useEffect(() => {
    fetchSuggestionsData();
  }, []);

  return { suggestions, loadingSuggestions, refetchSuggestions: fetchSuggestionsData };
};
